class StateChangeModalController {
  /* @ngInject */
  constructor($uibModalInstance, $http, $state, Session, data, reasons) {
    this.$uibModalInstance = $uibModalInstance;
    this.$http = $http;
    this.$state = $state;
    this.Session = Session;
    this.case = data.case;
    this.state = data.state;
    this.reasons = reasons;
  }

  $onInit() {
    this.user = this.Session.read('userinfo') || {};
    this.isVendor = this.user.client.type === 'VENDOR';
    this.data = {
      stateId: this.state.state_id,
      tat: false,
      tatAction: (this.case.tatActivity && this.case.tatActivity.tat_action === 'Start')
        ? 'Stop' : 'Start',
    };

    this.reasons = this.reasons
      .map(item => Object.assign(item, {
        status: false,
        comment: '',
      }));
  }

  submit(form) {
    if (form.$invalid || this.submitting) return;

    if (this.stateFile) {
      this.data.file = this.stateFile;
    }

    this.submitting = true;
    const reasons = this.reasons.filter(item => item.status);

    this.data.reasons = reasons;

    this.$http.put(`/case/${this.case.id}/state`, this.data)
      .then(() => this.reload())
      .catch(() => (this.submitting = false));

      // .then(({ data }) => {
      //   return this.reload();
      //   if (!reasons.length) return this.reload();

      //   const options = {
      //     reasons,
      //     caseStateId: data,
      //   };

      //   return this.$http.post('/caseStateReason', options)
      //     .then(() => this.reload());
      // })
      // .catch(() => (this.submitting = false));
  }

  reload() {
    this.submitting = false;
    this.$uibModalInstance.close();
    this.$state.reload();
  }
}

export default StateChangeModalController;



// WEBPACK FOOTER //
// ./client/components/state-change-modal/state-change-modal.js